const allowedByCookieConst = false;

const getCookieValidation = $el => {
	const $$cookieName = $el.find('.cookie_2click').attr('data-cookie');
  
	if ($$cookieName) {
	  let cookieValues = ''
  
	  const nameEQ = "externalSources=";
	  const ca = document.cookie.split(';');
	  for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		if (c.indexOf(nameEQ) === 0) {
		  cookieValues = c.substring(nameEQ.length, c.length);
  
		  break;
		}
		while (c.charAt(0) === ' ') {
  
		  c = c.substring(1, c.length);
		  if (c.indexOf(nameEQ) === 0) {
			cookieValues = c.substring(nameEQ.length, c.length);
  
			break;
		  }
		}
	  }
  
	  let allowedByCookie = false;
	  if ($('body').hasClass('is-IE')) {
		if (cookieValues.split(',').indexOf($$cookieName) > 0) {
		  allowedByCookie = true;
		} else {
		  allowedByCookie = false;
		}
	  } else {
		allowedByCookie = cookieValues.split(',').includes($$cookieName)
	  }
  
	  return allowedByCookie;
	} 
	  return allowedByCookieConst;
	
}

const videoSlider = () => {

	

	const positionSliderControl = () => {
		const $slider = $('.video-slider__inner');
		const $sliderContent = $('.swiper-slide-active .video-slider__additional-content');
		if ($slider.length !== 0 && $sliderContent.length !== 0) {
			const sliderOffset = $slider.offset().top;
			const contentOffset = $sliderContent.offset().top;
			const controlOffset = contentOffset - sliderOffset - 40;
			$('.swiper-pagination').css('top', controlOffset);
			$('.slider-arrow').css('top', controlOffset);
			window.requestAnimationFrame(positionSliderControl);
		}
	}

	if(getCookieValidation($('.video-slider'))){
		$('.video-slider .modal_revoke').show();
	}

	$('.cookie_2click').click(function () {
		if(getCookieValidation($('.video-slider'))){
			$('.video-slider .modal_revoke').show();
		}
	});	

	$(window).resize(() => {
		positionSliderControl();
	})

	window.requestAnimationFrame(positionSliderControl);

	positionSliderControl();
};

export default videoSlider;